import { ComboBox, ComboBoxChangeEvent } from "@progress/kendo-react-dropdowns";
import { GridCellProps } from "@progress/kendo-react-grid";

export interface KeyValGridCellProps extends GridCellProps {
  localizedData: { text: string; value: any }[];
}

export function ComboBoxCell(props: KeyValGridCellProps) {
  const { dataItem, field, onChange, localizedData } = props;

  const handleChange = (e: ComboBoxChangeEvent) => {
    if (onChange) {
      onChange({
        dataIndex: 0,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const myField = field || "";
  const dataValue = dataItem[myField] === null ? "" : dataItem[myField];

  return (
    <td>
      {dataItem.inEdit ? (
        <ComboBox
          onChange={handleChange}
          value={localizedData.find((c) => c.value === dataValue)}
          suggest
          data={localizedData}
          textField="text"
        />
      ) : (
        localizedData.find((val) => val.value === dataValue)?.text
      )}
    </td>
  );
}
